export const ultimasNoticias = [
    {
        "imagen" : "../assets/imgs/fiestam4.jpg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-fiesta-mexicana-con-la-oseh-2023/",
        "titulo" : "Fiesta Mexicana",
        "fecha" : "miercoles 20 de septiembre del 2023, 18:00 horas"
    },
    {
        "imagen" : "../assets/imgs/fiestam3.jpg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-fiesta-mexicana-con-la-oseh-2023/",
        "titulo" : "Fiesta Mexicana",
        "fecha" : "miercoles 20 de septiembre del 2023, 18:00 horas"
    },
    {
        "imagen" : "../assets/imgs/fiestam2.jpg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-fiesta-mexicana-con-la-oseh-2023/",
        "titulo" : "Fiesta Mexicana",
        "fecha" : "miercoles 20 de septiembre del 2023, 18:00 horas"
    },
    {
        "imagen" : "../assets/imgs/fiestam1.jpg",
        "url" : "https://taquilla.cecultah.gob.mx/events/concierto-fiesta-mexicana-con-la-oseh-2023/",
        "titulo" : "Fiesta Mexicana",
        "fecha" : "miercoles 20 de septiembre del 2023, 18:00 horas"
    },
    {
        "imagen" : "../assets/imgs/movilidadArtistica.jpg",
        "titulo" : "Apoyo a Instituciones Estatales de Cultura AIEC 2023",
        
    },
]